"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("../core");
var _metaProps = require("../metaProps");
/**
 *
 * @example ../../sample-site/csvlink.example.md
 */
class CSVLink extends _react.default.Component {
  static defaultProps = _metaProps.defaultProps;
  static propTypes = _metaProps.propTypes;
  constructor(props) {
    super(props);
    this.buildURI = this.buildURI.bind(this);
  }
  buildURI() {
    return (0, _core.buildURI)(...arguments);
  }

  /**
   * In IE11 this method will trigger the file download
   */
  handleLegacy(event) {
    let isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // If this browser is IE 11, it does not support the `download` attribute
    if (window.navigator.msSaveOrOpenBlob) {
      // Stop the click propagation
      event.preventDefault();
      const {
        data,
        headers,
        separator,
        filename,
        enclosingCharacter,
        uFEFF
      } = this.props;
      const csvData = isAsync && typeof data === "function" ? data() : data;
      let blob = new Blob([uFEFF ? "\uFEFF" : "", (0, _core.toCSV)(csvData, headers, separator, enclosingCharacter)]);
      window.navigator.msSaveBlob(blob, filename);
      return false;
    }
  }
  handleAsyncClick(event) {
    const done = proceed => {
      if (proceed === false) {
        event.preventDefault();
        return;
      }
      this.handleLegacy(event, true);
    };
    this.props.onClick(event, done);
  }
  handleSyncClick(event) {
    const stopEvent = this.props.onClick(event) === false;
    if (stopEvent) {
      event.preventDefault();
      return;
    }
    this.handleLegacy(event);
  }
  handleClick() {
    return event => {
      if (typeof this.props.onClick === "function") {
        return this.props.asyncOnClick ? this.handleAsyncClick(event) : this.handleSyncClick(event);
      }
      this.handleLegacy(event);
    };
  }
  render() {
    const {
      data,
      headers,
      separator,
      filename,
      uFEFF,
      children,
      onClick,
      asyncOnClick,
      enclosingCharacter,
      ...rest
    } = this.props;
    const isNodeEnvironment = typeof window === "undefined";
    const href = isNodeEnvironment ? "" : typeof data === "string" && /^blob:/.test(data) ? data : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      download: filename
    }, rest, {
      ref: link => this.link = link,
      target: "_self",
      href: href,
      onClick: this.handleClick()
    }), children);
  }
}
var _default = exports.default = CSVLink;